import styles from "./IECCustomWebpages.module.css";
import { useNavigate } from "react-router-dom";

import ChevronLeftIcon from "../../imgs/chevron-left-icon.png";

import princetonLogo from "../../imgs/school-assets/princeton-logo.png";
import mitLogo from "../../imgs/school-assets/mit-logo.jpg";
import stanfordLogo from "../../imgs/school-assets/stanford-logo.png";
import northwesternLogo from "../../imgs/school-assets/northwestern-logo.png";
import jhuLogo from "../../imgs/school-assets/jhu-logo.jpg";
import dukeLogo from "../../imgs/school-assets/duke-logo.png";
import upennLogo from "../../imgs/school-assets/upenn-logo.png";
import cornellLogo from "../../imgs/school-assets/cornell-logo.png";
import uchicagoLogo from "../../imgs/school-assets/uchicago-logo.png";
import columbiaLogo from "../../imgs/school-assets/columbia-logo.png";

export default function ALeaguePage() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.dashboard_return} onClick={() => navigate("/iec")}>
                <img
                    className={styles.dashboard_return_icon}
                    src={ChevronLeftIcon}
                    alt="return to application dashboard icon"
                />
                Talk to a Human
            </div>
            <div className={styles.header}>
                <h1>A. League Consulting</h1>
                <p className={styles.location}>📍 Taipei, TW</p>
                <p className={styles.description}>
                    A. League is dedicated to guiding motivated and high-potential high school students on their journey
                    to higher education. We believe that success is not solely defined by academic scores, but by a
                    student's character, ambition, and long-term vision. Through holistic assessments, personalized
                    counseling, and strong global connections, A. League serves not just as an education consultant, but
                    as a trusted partner in each student's path to growth and success.
                </p>
            </div>
            <div className={styles.stats_section}>
                <div className={styles.stats_card}>
                    <h2>500+</h2>
                    <p>Students matriculated at top universities</p>
                </div>
                <div className={styles.stats_card}>
                    <h2>$12M</h2>
                    <p>In scholarships and fellowships awarded</p>
                </div>
            </div>
            <div className={styles.video_section}>
                <h2>Meet A. League Consulting</h2>
                <iframe src="https://www.youtube.com/embed/ltjcK4gNcr0"></iframe>
            </div>
            <div className={styles.universities_section}>
                <h2>Where A. League Students Were Accepted Last Year</h2>
                <div className={styles.university_cards}>
                    <div className={styles.university_card}>
                        <img src={princetonLogo} alt="Princeton University" />
                        <p> Princeton University</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={mitLogo} alt="MIT" />
                        <p> MIT</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={stanfordLogo} alt="Stanford University" />
                        <p> Stanford University</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={northwesternLogo} alt="Northwestern University" />
                        <p> Northwestern University</p>
                    </div>

                    <div className={styles.university_card}>
                        <img src={jhuLogo} alt="JHU" />
                        <p> Johns Hopkins University</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={dukeLogo} alt="Duke University" />
                        <p> Duke University</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={upennLogo} alt="UPenn" />
                        <p> University of Pennsylvania</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={cornellLogo} alt="Cornell University" />
                        <p> Cornell University</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={uchicagoLogo} alt="UChicago" />
                        <p> University of Chicago</p>
                    </div>
                    <div className={styles.university_card}>
                        <img src={columbiaLogo} alt="Columbia University" />
                        <p> Columbia University</p>
                    </div>
                </div>
            </div>
            <div className={styles.cta_section}>
                <h1>Ready to Start Your Journey?</h1>
                <p>Connect with A. League Consulting today and take the first step towards your dream university.</p>
                <button onClick={() => window.open("https://aleague.org/en/contact", "_blank", "noopener noreferrer")}>
                    Schedule a Free Consultation
                </button>
            </div>
        </div>
    );
}
